import { useMutation } from '@apollo/client'
import { useSnackbar } from 'notistack'
import { useContext, useEffect, useState } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { AddEditPageContext } from 'features/inventory/page/contexts/AddEditPageContext'
import { mapGraphQLErrors } from 'providers/graphql'
import { EditSchema } from '../../schemas/editSchema'
import { Data, mapper, UPDATE_PAGE } from './api'
import { UseUpdatePage } from './types'

export const useUpdatePage = (): UseUpdatePage => {
  const { t } = useTranslation('features/page')
  const { enqueueSnackbar } = useSnackbar()
  const { setLoading } = useContext(AddEditPageContext)
  const [errors, setErrors] = useState<FieldErrors<EditSchema>>({})

  const [mutateUpdatePage, { loading }] = useMutation(UPDATE_PAGE, {
    onCompleted: ({ updatePage: { errors } }: Data): void => {
      if (errors && errors.length > 0) {
        setErrors(mapGraphQLErrors(errors))
        enqueueSnackbar(t('form.error.update'), { variant: 'error' })
      } else {
        setErrors({})
        enqueueSnackbar(t('form.success.update'), { variant: 'success' })
      }
    },
    refetchQueries: ['getPage'],
  })

  useEffect(() => {
    setLoading(loading)
  }, [loading])

  const updatePage = (data: EditSchema): void => {
    mutateUpdatePage({
      variables: {
        input: mapper(data),
      },
    })
  }

  return { errors, updatePage }
}
